import { createAsyncThunk } from '@reduxjs/toolkit'
import { decryptData } from 'utils/common-services/decrypt.service'
import { getAllCurrencyService, getGameSettingService, verifyRoundHashService } from 'network/services/gameSettings.service'
import { setAllCurrency } from 'redux-store/redux/slices/gameSettings.slice'

export const getAllCurrency = createAsyncThunk('user/getAllCurrency', async (data, thunkApi) => {
  try {
    const res = await getAllCurrencyService()
    thunkApi.dispatch(setAllCurrency(res))
    if (res && res.length > 0) {
      thunkApi.dispatch(getGameSetting(data))
    }
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const getGameSetting = createAsyncThunk('system/get-game-settings', async (data, thunkApi) => {
  try {
    let res = await getGameSettingService(data)
    res = await decryptData(res?.encryptedData, res?.iv)
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const roundVerifyHash = createAsyncThunk(
  'verify/game-hash',
  async (data, thunkApi) => {
    try {
      const res = await verifyRoundHashService(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)
